import { FC, SVGProps } from 'react'

export const IconBriefcase: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="46"
    height="46"
    viewBox="0 0 46 46"
    stroke="#0062CA"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M38.3333 13.4166H7.66659C5.54949 13.4166 3.83325 15.1329 3.83325 17.25V36.4166C3.83325 38.5337 5.54949 40.25 7.66659 40.25H38.3333C40.4503 40.25 42.1666 38.5337 42.1666 36.4166V17.25C42.1666 15.1329 40.4503 13.4166 38.3333 13.4166Z"
      fill="none"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.6666 40.25V9.58333C30.6666 8.56667 30.2627 7.59165 29.5438 6.87276C28.8249 6.15387 27.8499 5.75 26.8333 5.75H19.1666C18.1499 5.75 17.1749 6.15387 16.456 6.87276C15.7371 7.59165 15.3333 8.56667 15.3333 9.58333V40.25"
      fill="none"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
